<template>
    <div class="container">
        <b-modal
            :model-value="modalCrear"
            :no-close-on-backdrop="true"
            hide-footer
            hide-header-close
            centered
            :title="labels.title"
            header-class="reset-modal-header"
            title-class="reset-modal-title"
            body-class="reset-modal-body"
            class="reset-password-dialog"
        >
            <div class="uniform-modal-body">
                <div class="password-policy-box mb-3">
                    <div class="password-policy-title">
                        {{ labels.formInfoTitle }}
                    </div>
                    <div class="password-policy-item">
                        {{ labels.formInfoSubtitle }}
                    </div>
                </div>
                <b-col md="4" lg="12" class="p-0 mx-auto">
                    <b-form-group>
                        <label>{{ labels.calificacion }}</label>
                        <b-form-input
                            v-model="form.calificacion"
                            type="text"
                            class="reset-input"
                        ></b-form-input>

                        <label>{{ labels.descripcion }}</label>
                        <b-form-input
                            v-model="form.descripcion"
                            type="text"
                            class="reset-input"
                        ></b-form-input>

                        <label>{{ labels.score }}</label>
                        <b-form-input
                            v-model="form.score"
                            type="number"
                            class="reset-input"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
                <div class="reset-dialog-actions d-flex justify-content-end mt-3 uniform-actions-wrap">
                    <b-button
                        class="mr-2 reset-btn-secondary"
                        @click="cierraModal()"
                    >
                        {{ labels.close }}
                    </b-button>
                    <b-button
                        class="reset-btn-primary"
                        @click="guardarCalificacion()"
                    >
                        {{ labels.save }}
                    </b-button>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
import Calificacion from '../../../services/Calificacion'; 
export default {
    name : 'Crear',
    props:{
        modalCrear: {
            type: Boolean,
            default: false
        },
        infoVigencia: {
            type: String
        }
    },
    data () {
        return {
            form : {
                calificacion : '',
                score : null,
                descripcion : '',
            }
        }
    },
    computed:{
        labels(){
            if(this.$store.state._language == "es-ES"){ 
                return {
                    title : 'Crear calificación',
                    vigencia : 'Vigencia',
                    calificacion : 'Calificación',
                    score : 'Score',
                    descripcion : 'Descripción',
                    save : 'Guardar',
                    close : 'Cerrar',
                    formInfoTitle: "Datos de la calificación",
                    formInfoSubtitle: "Completa la información y guarda la nueva calificación.",
                }
            }else{
                return {
                    title : 'Create Rating',
                    vigencia : 'Validity',
                    calificacion : 'Rating',
                    score : 'Score',
                    descripcion : 'Description',
                    save : 'Save',
                    close : 'Close',
                    formInfoTitle: "Qualification details",
                    formInfoSubtitle: "Complete the information and save the new rating.",
                }
            }
        }
    },
    methods:{
        guardarCalificacion(){

            if (!this.form.calificacion || !this.form.descripcion || !this.form.score) {
                this.$toast.error("Campo(s) pendiente(s) por diligenciar");
                return;
            }

            let info = {
                'vigencia' : this.infoVigencia, 
                'calificacion' : this.form.calificacion, 
                'descripcion' : this.form.descripcion, 
                'score' : this.form.score, 
                'idUser' : this.$store.state.userId 
            }

            Calificacion.createCalificacion(info) 
            .then((res) => { 
                if(res.status == 201){ 
                    this.$toast.success(res.data.message) 
                    this.$emit("creado");
                    this.cierraModal();
                }
            })
            .catch((err) => { 
                if(err.response.status == 400){ 
                    this.$toast.error(err.response.data.message) 
                }
            })
        },
        cierraModal(){
            this.cleanInp()
            this.$emit('cierraModal',false) 
        },
        cleanInp(){
            this.form.calificacion = "";
            this.form.descripcion = "";
            this.form.score = null;
        }
    }
}
</script>

<style>

</style>
